/** What this build is: a release tag on production, the commit on staging, empty locally. Not a
 *  link to the GitHub release — the repository is private, so that page 404s for app users. */
export const APP_VERSION = (process.env.REACT_APP_VERSION || '').trim();
